import { PasswordSubmitMethodFormFields } from '~/scenes/PeopleModule/components/EmployeeActions/ResetPassword/PasswordSubmissionMethodForm/data';
import { fetchFromOldApi } from '~/services/Http';

export type ResetPasswordForm = {
  userName: string;
  passwordSubmit: PasswordSubmitMethodFormFields;
};

export type ResetPasswordType = {
  fLoginUserEmail: string | undefined;
  fLoginUsername: string | undefined;
  fSmsPhoneNumber: string | undefined;
};

export const postRestPassword = async (json: ResetPasswordType) => {
  return await fetchFromOldApi('/form/user/reset', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};
